var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-411.000000, -390.000000)",
    fill: "#B4C3D0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account",
    transform: "translate(0.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0666667,36.5126064 C53.0648554,37.1230322 53.0648554,37.7352856 53.063044,38.3457113 C53.063044,38.4352648 53.0485536,38.5248183 53.0213839,38.6070613 C52.9724786,38.7550987 52.8819131,38.8775493 52.7714232,38.9433437 C52.7279518,38.970758 52.6808578,38.9872066 52.6337637,38.9963448 C52.6192732,38.9981724 52.6047828,39 52.5921036,39 L52.5667453,39 L37.4296321,39 C37.4151416,39 37.4006512,39 37.3861607,38.9981724 C37.335444,38.9926895 37.2847274,38.9780685 37.2376333,38.9506542 C37.1235208,38.8866874 37.0275214,38.7624091 36.9768048,38.6107165 C36.9496351,38.5339564 36.936956,38.4517134 36.9333333,38.3694704 L36.9333333,38.3365732 L36.9333333,36.1872897 L36.9333333,32.888432 C37.6071405,30.6093873 41.157307,30.2 42.5465813,30.2 L47.3628532,30.2 C48.7521275,30.2 52.40735,31.09919 53.0340631,32.9743302 L53.0666667,36.5126064 L53.0666667,36.5126064 Z M44.9990149,17 C47.8360903,17 50.1333333,19.2972867 50.1333333,22.1333333 C50.1333333,24.96938 47.8360903,27.2666667 44.9990149,27.2666667 C42.1639097,27.2666667 39.8666667,24.96938 39.8666667,22.1333333 C39.8666667,19.2972867 42.1639097,17 44.9990149,17 L44.9990149,17 Z",
    id: "ic/account"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon_account.dec6ede625f713ad57fd21672ec195af.svg";
export { ForwardRef as ReactComponent };